// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"927a0156","821":"f3c72275"}[chunkId] + ".chunk.js";
};